/**
 * CategoryFilter Component
 * Horizontal filter pills for blog categories
 */
import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/utils';
import { getAllCategories } from '../../content/blogs';

// Selected state colors matching BlogCard category badges (using design system colors)
const selectedColors = {
  all: 'bg-primary-500 text-white shadow-md shadow-primary-500/25',
  primary: 'bg-primary-500 text-white shadow-md shadow-primary-500/25',
  secondary: 'bg-secondary-500 text-white shadow-md shadow-secondary-500/25',
  accent: 'bg-accent-500 text-white shadow-md shadow-accent-500/25',
  info: 'bg-info-500 text-white shadow-md shadow-info-500/25',
  success: 'bg-success-500 text-white shadow-md shadow-success-500/25',
};

const CategoryFilter = ({ selected, onSelect }) => {
  const { i18n } = useTranslation();
  const language = i18n.language || 'es';
  const categories = getAllCategories();

  const allOption = {
    id: 'all',
    label: {
      es: 'Todos',
      en: 'All',
    },
    color: 'all',
  };

  const options = [allOption, ...categories];

  return (
    <div className="flex flex-wrap justify-center gap-2">
      {options.map((category) => {
        const isSelected = selected === category.id;
        const label = category.label[language] || category.label.es;
        const colorKey = category.color || 'primary';

        return (
          <motion.button
            key={category.id}
            onClick={() => onSelect(category.id)}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className={cn(
              'rounded-full px-4 py-2 text-sm font-medium',
              'transition-all duration-200',
              isSelected
                ? selectedColors[colorKey] || selectedColors.primary
                : 'bg-neutral-100 text-neutral-700 hover:bg-neutral-200 dark:bg-neutral-800 dark:text-neutral-300 dark:hover:bg-neutral-700'
            )}
          >
            {label}
          </motion.button>
        );
      })}
    </div>
  );
};

export default CategoryFilter;
